/**
 * Employee Web — `/me/loans/new` submit form route.
 *
 * Phase 17 Plan 02. RHF + Zod loan-request form gated on `loan:request:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { SubmitLoanForm } from "../features/loans/SubmitLoanForm";

export const Route = createFileRoute("/_auth/me/loans/new")({
  staticData: { breadcrumb: { labelKey: "loans:submit.title" } },
  beforeLoad: requirePermission({
    anyOf: ["loan:request:self"],
    defaultRoute: "/me/overview",
  }),
  component: NewLoanRoute,
});

function NewLoanRoute(): JSX.Element {
  return <SubmitLoanForm />;
}
